import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlCreditoRoutingModule } from './control-credito-routing.module';
import { ControlCreditoIndexComponent } from './control-credito-index/control-credito-index.component';
import { ReporteSaldosComponent } from './reportes/reporte-saldos/reporte-saldos.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalCrearNotificacionComponent } from './reportes/modales/modal-crear-notificacion/modal-crear-notificacion.component';
import { ModalHistorialEstadosComponent } from './reportes/modales/modal-historial-estados/modal-historial-estados.component';
import { ModalActualizarEstadoComponent } from './reportes/modales/modal-actualizar-estado/modal-actualizar-estado.component';
import { ModalReporteAerovalesComponent } from "@controlCredito/reportes/modales/modal-reporte-aerovales/modal-reporte-aerovales.component";
import { SharedModule } from "@shared/shared.module";
import { ReporteSaldoDetalleComponent } from "@controlCredito/reportes/reporte-saldos/reporte-saldo-detalle/reporte-saldo-detalle.component";
import { ReporteAprobadorComponent } from "@controlCredito/reportes/reporte-saldos/reporte-aprobador/reporte-aprobador.component";
import { ReporteSolicitanteComponent } from "@controlCredito/reportes/reporte-saldos/reporte-solicitante/reporte-solicitante.component";

@NgModule({
  declarations: [
    ControlCreditoIndexComponent,
    ReporteSaldosComponent,
    ModalCrearNotificacionComponent,
    ModalHistorialEstadosComponent,
    ModalActualizarEstadoComponent,
    ModalReporteAerovalesComponent,
    ReporteSaldoDetalleComponent,
    ReporteAprobadorComponent,
    ReporteSolicitanteComponent
  ],
    imports: [
        CommonModule,
        NgxSpinnerModule,
        ControlCreditoRoutingModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        InfiniteScrollDirective,
        SharedModule
    ]
})
export class ControlCreditoModule { }
